import React from 'react';
import { Route } from 'react-router-dom';
import { Role, useAuthentication } from '../../contexts/Authentication';
import { RouteInterface } from '../../routes/routes';

export const allowedRoute = (userRoles: Role[], isLogged: boolean, props: RouteInterface) => {
  if (!props.roles)
    return true;
  
  return (isLogged && userRoles.some(userRole => props.roles && props.roles?.findIndex(r => r === userRole) >= 0));
}

const ProtectedRoute = (props: RouteInterface) => {
  const auth = useAuthentication();

  return (
    <>
    { allowedRoute(auth.role, auth.isLogged, props) &&
      <Route {...props} />
    }
    </>
  );
}

export default ProtectedRoute;